<div class="discussions">
  <div *ngIf="nbDiscussions > 0; else noDiscussion" class="discussions__body">
    <button
      *ngIf="nbDiscussions > maxCommentsToDisplay"
      class="discussions__body__seeAllMsg"
      (click)="openDiscussionModal()"
    >
      <ng-container i18n="@@DISCUSSIONS.SEE_ALL_COMMENTS">See all {{ nbDiscussions }} comments</ng-container>
    </button>
    <div class="discussions__body__translate">
      <span class="discussions__body__translateByGoogle vc-text-xs" i18n="@@DISCUSSIONS.TRANSLATE_BY_GOOGLE">
        Translated by Google
      </span>

      <button class="discussions__body__translateAll vc-text-s" (click)="toggleTranslateAll()">
        <vc-sprite-icons class="discussions__body__translateAll__icon" [name]="'translation'"></vc-sprite-icons>
        <span i18n="@@DISCUSSIONS.VIEW_ORIGINAL_VERSION" *ngIf="translateAll; else translateAllText"
          >See Original Version</span
        >
        <ng-template #translateAllText><span i18n="@@DISCUSSIONS.TRANSLATE_ALL">Translate all</span></ng-template>
      </button>
    </div>
    <div class="discussions__body__list">
      <ng-container *ngIf="commentsList$ | async as commentsList">
        <vc-message
          *ngFor="let message of commentsList"
          class="discussions__body__list__message"
          [likedItem]="likedItem"
          [message]="message"
          [translateAll]="translateAll"
          [product]="product"
          [negotiation]="getNegoByAuthorId(message.author.id)"
          [reservation]="reservation"
          [user]="userInfo"
          [editoId]="editoId"
          [showLikeFunctionality]="showLikeFunctionality"
        ></vc-message>
      </ng-container>
    </div>
  </div>

  <div class="discussions__addMessage">
    <vc-discussions-form
      [isAuthenticated]="isAuthenticated"
      [userInfo]="userInfo"
      [idItem]="product?.id ? product.id : editoId"
      [commentType]="commentType"
      (send)="addNewComment($event)"
    ></vc-discussions-form>
  </div>
</div>

<ng-template #noDiscussion>
  <div class="discussions__empty vc-bodymaxCommentsToDisplay">
    <vc-loader *ngIf="isFetching"></vc-loader>
    <ng-container *ngIf="!isFetching">
      <vc-sprite-icons name="talk" class="discussions__empty__icon"></vc-sprite-icons>
      <span i18n="@@DISCUSSIONS.NO_DISCUSSION" class="vc-title-xs">Be the first to leave a comment</span>
    </ng-container>
  </div>
</ng-template>
